// TODO: Move to commonUtils and write test.
export const EXTRACT_TAB_ID = (url) =>
  (url.split(/tab/) && url.split(/tab/)[1]) || '';
